module.exports = __webpack_public_path__ + "img/train2.67599277.png";